<template>
  <footer class="footer">
    <div class="container text-center">
      <!-- <nav>
        <ul>
          <li>
            <a href="" target="_blank" style="pointer-events: none; cursor: default;">
              <font color="#c2c2c2">Instrukcja (wkrótce)</font>
            </a>
          </li>
        </ul>
      </nav> -->
      <div class="copyright">
        &copy; Posnet {{ new Date().getFullYear() }} - v{{ this.$appVersion }} - Wykonanie: <a href="https://sekafi.pl" target="_blank">Fiskas</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
